import {ApiProvider} from '../providers/api/api';
import {AuthenticationProvider} from '../providers/authentication';
import {SettingsProvider} from '../providers/settings';
import {Component, ViewChild} from '@angular/core';
import {Platform, MenuController, Events} from 'ionic-angular';
import {Nav, NavController} from 'ionic-angular';
import {LoaderProvider} from "../providers/loader";

@Component({
    templateUrl: 'app.html'
})
export class MyApp {

    brand: any = {name: ''}
    rootPage: any = 'LoginPage';
    user: any = {id: 0, nome: '', cpf: '', grupo: 0};
    pages: any[] = [];
    currentURL:string;

    @ViewChild(Nav) nav: Nav;

    constructor(platform: Platform,
                public menuCtrl: MenuController,
                public auth: AuthenticationProvider,
                public eApi: ApiProvider,
                public set: SettingsProvider,
                public events: Events,
                public loader: LoaderProvider) {

        this.currentURL = window.location.href;
        let resetPage = this.currentURL.includes("reset-password");
        if(!resetPage) {
            platform.ready().then(() => {
                this.auth
                    .loadUserCredentials()
                    .then(res => {
                        if (res == null) {
                            this.exit();
                        }
                    });
            });
        } else {
            let sep = this.currentURL.split("=");
            if(sep[1]) {
                this.set.saveCachedData("_key_change_pass", sep[1]);
            } else {
                platform.ready().then(() => {
                    this.auth
                        .loadUserCredentials()
                        .then(res => {
                            if (res == null) {
                                this.exit();
                            }
                        });
                });
            }
        }

        this.brand.name = 'Jaraguá Tenis Clube';

        events.subscribe('reload:fnLogout', () => {
            this.fnLogout();
        });

        events.subscribe('reload:fnMontaMenu', () => {
            this.fnMontaMenu();
        });

    }

    fnMontaMenu() {
        this.set.loadSetting("session").then(res => {
            if(res != null) {
                this.user = res.data;
                let admin = (parseInt(res.data.admin) > 0);
                this.pages = [
                    {title: 'Meus Dados', component: 'AccountPage', icon: 'at', hidden: false},
                    {title: 'Faturas', component: 'FaturasPage', icon: 'bookmarks', hidden: false},
                    {title: 'Mensagens', component: 'PushMessagesPage', icon: 'chatboxes', hidden: !admin},
                    {title: 'Remessa', component: 'RemessaPage', icon: 'cloud-upload', hidden: !admin},
                    {title: 'Retorno', component: 'RetornoPage', icon: 'cloud-download', hidden: !admin},
                    {title: 'Sócios', component: 'UsuarioPage', icon: 'contact', hidden: !admin}
                ];
            }
        });
    }

    fnLogout() {
        this.pages = [];
        this.auth.destroyUserCredentials();
        this.menuCtrl.enable(false, 'authenticated');
        this.rootPage = 'LoginPage';
        this.nav.setRoot('LoginPage');
    }

    validarSessao() {
        this.auth
            .loadUserCredentials()
            .then(res => {
                this.user = this.auth.user;
                if (res == undefined || !this.auth.authenticated) {
                    this.rootPage = 'LoginPage';
                }
            })
    }

    openPage(page) {
        this.loader.show();
        this.auth
            .loadUserCredentials()
            .then(res => {
                if (res == undefined || !this.auth.authenticated) {
                    this.rootPage = 'LoginPage';
                }
                this.nav.setRoot(page);
            })
    }

    enableAuthenticatedMenu() {
        this.menuCtrl.enable(true, 'authenticated');
        this.menuCtrl.enable(false, 'unauthenticated');
    }

    onChange() {
        this.set.saveCachedData("Account", this.user);
        this.nav.setRoot('FaturasPage');
    }

    exit() {
        this.auth.destroyUserCredentials();
        this.menuCtrl.enable(false, 'authenticated');
        this.rootPage = 'LoginPage';
        this.nav.setRoot('LoginPage');
    }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts